import { render } from "./BudgetItemGrid.vue?vue&type=template&id=7451ee4c&scoped=true"
import script from "./BudgetItemGrid.vue?vue&type=script&lang=js"
export * from "./BudgetItemGrid.vue?vue&type=script&lang=js"

import "./BudgetItemGrid.vue?vue&type=style&index=0&id=7451ee4c&scoped=true&lang=css"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7451ee4c"]])

export default __exports__